

























































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { login1, login2 } from '@/api/users'
import { Base64 } from 'js-base64'
import { getCookie, setCookie, removeCookie } from '@/utils/cookies'
import { getChaos } from '@/utils/fix'
import { Route } from 'vue-router'
import { getToken } from '@/api/common'

type Dictionary<T> = { [key: string]: T }

// 1: 域账号, 2: 兔兔账号
type accountType = 1 | 2
@Component({
  name: 'Login'
})
export default class extends Vue {
  // api data
  loginForm1 = {
    account: '',
    password: ''
  }
  loginForm2 = {
    account: '',
    password: ''
  }
  // template data
  isRemember1 = false
  isRemember2 = false

  loading = false

  accountType: accountType = 1
  redirectPath?: string
  otherQuery: Dictionary<string> = {}
  // 添加自定义验证逻辑
  validateAccount = (rule: any, value: string, cb: Function) => {
    if (value.length === 0) {
      cb(new Error('账号不能为空'))
    } else {
      cb()
    }
  }
  validatePassword = (rule: any, value: string, cb: Function) => {
    if (value.length === 0) {
      cb(new Error('密码不能为空'))
    } else {
      cb()
    }
  }
  loginRules1 = {
    account: [{ validator: this.validateAccount, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }
  loginRules2 = {
    account: [{ validator: this.validateAccount, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }

  created() {
    this.getUserInfo(this.accountType)
  }

  // methods
  async lpadLogin() {
    let res: any = await login1(this.loginForm1)
    if (res && res.status.code === 0) {
      this.loading = false
      setCookie('token', res.data.token || '')
      this.$router.push({
        path: this.redirectPath || '/',
        query: this.otherQuery
      })
      this.setUserInfo(1)
      localStorage.setItem('userInfo', JSON.stringify(res.data))
      // this.$nextTick(async() => { await getChaos() })
    } else {
      this.loading = false
    }
  }
  async tutuLogin() {
    let res: any = await login2(this.loginForm2)
    if (res && res.status.code === 0) {
      this.loading = false
      setCookie('token', res.data.token || '')
      this.$router.push({
        path: this.redirectPath || '/',
        query: this.otherQuery
      })
      this.setUserInfo(2)
      localStorage.setItem('userInfo', JSON.stringify(res.data))
    } else {
      this.loading = false
    }
  }
  getUserInfo(type: accountType) {
    // 判断当前登录方式
    if (type === 1) {
      let account = getCookie('account1')
      let pwd = getCookie('pwd1') as string
      let password = pwd && Base64.decode(pwd as string)
      if (account && pwd) {
        this.loginForm1.account = account
        this.loginForm1.password = password
        this.isRemember1 = true
      }
    } else {
      let account = getCookie('account2')
      let pwd = getCookie('pwd1') as string
      let password = pwd && Base64.decode(pwd as string)
      if (account && pwd) {
        this.loginForm2.account = account
        this.loginForm2.password = password
        this.isRemember2 = true
      }
    }
  }
  setUserInfo(type: accountType) {
    if (type === 1) {
      // 不建议记住密码, 没必要
      // TODO:this[`isRemember1${type}`] 简化代码, ts error 提示
      if (this['isRemember1']) {
        setCookie('account1', this.loginForm1.account, { expires: 30 })
        let pwd = Base64.encode(this.loginForm1.password)
        setCookie('pwd1', pwd, { expires: 30 })
      } else {
        setCookie('account1', '')
        setCookie('pwd1', '')
      }
    } else {
      if (this['isRemember2']) {
        setCookie('account2', this.loginForm2.account, { expires: 30 })
        let pwd = Base64.encode(this.loginForm2.password)
        setCookie('pwd2', pwd, { expires: 30 })
      } else {
        setCookie('account2', '')
        setCookie('pwd2', '')
      }
    }
  }
  handleSwitch(type: accountType) {
    this.accountType = type
  }
  handleForget(type: accountType) {
    this.$router.push({
      path: '/find-password',
      query: {
        type: type.toString()
      }
    })
  }
  goToRegister() {}
  handleLogin(type: accountType) {
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 30000)
    if (type === 1) {
      (this.$refs['loginForm1'] as Form).validate((valid) => {
        if (valid) {
          this.lpadLogin()
        } else {
          this['$message'].error('请填写完整的账户和密码!')
          return false
        }
      })
    } else {
      (this.$refs['loginForm2'] as Form).validate((valid) => {
        if (valid) {
          this.tutuLogin()
        } else {
          this['$message'].error('请填写完整的账户和密码!')
          return false
        }
      })
    }
  }
  getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }
  @Watch('accountType')
  onLoginTypeChange() {
    this.getUserInfo(this.accountType)
  }
  // TODO: 其他路由重定向, 携带参数
  @Watch('$route', { immediate: true })
  onRouteChange(route: Route) {
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirectPath = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }
}
